import React from 'react';
import { useAuth } from '../context/AuthContext';
import StatusBadge from '../components/common/StatusBadge';
import StatusTimeline from '../components/common/StatusTimeline';

export default function ProgressPage() {
  const { student } = useAuth();
  const status = student?.status || 'New Lead';

  return (
    <div className="px-4 sm:px-6 py-6 max-w-2xl mx-auto animate-fade-in">
      {/* Page header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-slate-800">Application Progress</h1>
          <p className="text-sm text-slate-500 mt-0.5">Track your loan application status</p>
        </div>
        <StatusBadge status={status} size="lg" />
      </div>

      {/* Timeline card */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-card p-6 mb-5">
        <StatusTimeline currentStatus={status} />
      </div>

      {/* Help card */}
      <div className="bg-gradient-to-br from-brand-50 to-blue-50 rounded-2xl border border-brand-100 p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-brand-100 rounded-xl flex items-center justify-center shrink-0">
            <svg className="w-5 h-5 text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-semibold text-brand-800">Need help?</p>
            <p className="text-xs text-brand-600 mt-1 leading-relaxed">
              If you have questions about your application status, please contact your GBL Tree advisor directly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
